// extracted by mini-css-extract-plugin
module.exports = {"bottomAd_box":"bottomAd_box-1DxSTGlG","bottomAd":"bottomAd-2-kYuQBi"};